import VisibilityIcon from "@mui/icons-material/Visibility";
import {Dropdown} from "react-bootstrap";
import SettingsIcon from "@mui/icons-material/Settings";
import PopupOrderDetails from "../../Order/Components/PopupOrderDetails";
import DowloadEvidences from "../../ManualWriteOff/Components/DowloadEvidences";
import React from "react";
import DownloadDueDateChangeFiles from "./DownloadDueDateChangeFiles";


export default function DueDateChangesActions({item, setLoadData}) {

    const detailsLabel = <>
        <VisibilityIcon fontSize="medium"/>
        &nbsp; Detalhes do Lote
    </>

    return <Dropdown drop='down-centered'>
        <Dropdown.Toggle variant="secondary">
            Ações &nbsp;
            <SettingsIcon fontSize="medium"/>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <PopupOrderDetails
                item={item.pedido} setLoadData={setLoadData}
                label={detailsLabel} buttonClass={'dropdown-item'}/>
            <DownloadDueDateChangeFiles files={item.files}/>
        </Dropdown.Menu>

    </Dropdown>
}